module.exports = __webpack_public_path__ + "static/media/member1.701d40f3.jpg";